var React = require('react');

function ShoppingCart (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fa-group"},[React.createElement("path",{"className":"fa-secondary","fill":"currentColor","d":"M552 64H159.21l52.36 256h293.15a24 24 0 0 0 23.4-18.68l47.27-208a24 24 0 0 0-18.08-28.72A23.69 23.69 0 0 0 552 64z","opacity":"0.4","key":0}),React.createElement("path",{"className":"fa-primary","fill":"currentColor","d":"M218.12 352h268.42a24 24 0 0 1 23.4 29.32l-5.52 24.28a56 56 0 1 1-63.6 10.4H231.18a56 56 0 1 1-67.05-8.57L93.88 64H24A24 24 0 0 1 0 40V24A24 24 0 0 1 24 0h102.53A24 24 0 0 1 150 19.19z","key":1})]));
}

ShoppingCart.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fad","data-icon":"shopping-cart","className":"svg-inline--fa fa-shopping-cart fa-w-18","role":"img","viewBox":"0 0 576 512"};

module.exports = ShoppingCart;

ShoppingCart.default = ShoppingCart;
